import { Navigate, useLocation } from "react-router-dom";
import useGetPermission from "../../../hooks/useGetPermission";
import { LocalSetupRoutePopup } from "../../common";
import secondaryComponents from "..";
import { useEffect, useState } from "react";

const RoutePermissionRedirector = ({
  children,
  permissionParentKey,
  permissionChildKey,
  redirectPath = null,
  showOnLocalSetup = false,
  localPopUrlPath = null,
}) => {
  const { isPermitted, isLocalSetup } = useGetPermission({
    permissionParentKey,
    permissionChildKey,
    showOnLocalSetup,
  });
  const { pathname } = useLocation();
  const status = !isPermitted && isLocalSetup && localPopUrlPath !== null;
  const [isLocalPopup, setIsLocalPopup] = useState(status);
  useEffect(() => {
    setIsLocalPopup(status);
  }, [pathname]);

  return (
    <>
      {isPermitted ? (
        children
      ) : !isPermitted && redirectPath ? (
        <Navigate to={redirectPath} replace />
      ) : (
        <h4 className="mt-5 text-center">
          You are not permitted to view this resources
        </h4>
      )}

      <secondaryComponents.Modal
        isActive={isLocalPopup ? true : false}
        closeModal={() => {
          setIsLocalPopup(false);
        }}
        width={600}
      >
        <LocalSetupRoutePopup onlinePath={localPopUrlPath} />
      </secondaryComponents.Modal>
    </>
  );
};
export default RoutePermissionRedirector;
